import React, { useEffect, useState } from 'react';
import { ChevronDoubleRightIcon, ChevronDoubleLeftIcon } from "@heroicons/react/20/solid";
import ConfirmModal from '../Shared/ConfirmModal';

interface IssueRightSideBarProps {
    isOpen: boolean;
    onToggle: (isOpen: boolean) => void;
    selectedCount: number;
    onDeleteSelected: () => void;
    onCloseSelected: () => void;
}

const IssueRightSideBar: React.FC<IssueRightSideBarProps> = ({ isOpen, onToggle, selectedCount, onDeleteSelected, onCloseSelected }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [closeModalOpen, setCloseModalOpen] = useState(false);

    useEffect(() => {
        setIsSidebarOpen(isOpen);
    }, [isOpen]);

    const handleToggle = () => {
        setIsSidebarOpen(!isSidebarOpen);
        onToggle(!isSidebarOpen);
    };

    return (
        <aside
            className={`select-none fixed z-10 top-[4.1rem] block h-[calc(99vh-4rem)] right-0 shadow-md border-l border-r bg-white dark:bg-darkbg dark:border-gray-500 transition-transform transform duration-200 w-[19rem] ${isSidebarOpen ? "translate-x-0" : "translate-x-[100%]"}`}
        >
            <div className="mx-auto bg-gray-100 dark:bg-darkbglight">
                <div className="min-w-0 px-4 pt-2 pb-1">
                    <div className="text-gray-900 dark:text-gray-300 flex items-center space-x-2 justify-center">
                        <h3 className="text-center text-lg font-semibold leading-7 sm:text-base sm:tracking-tight">
                            Bulk Actions
                        </h3>
                    </div>
                </div>
            </div>
            <div>
                {selectedCount > 0 && (
                    <div className="flex flex-col gap-4 items-center justify-center py-4">
                        <p className="text-sm text-gray-600 dark:text-gray-300">
                            {selectedCount} issue{selectedCount > 1 ? 's' : ''} selected
                        </p>
                        <button
                            type="button"
                            className="flex items-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-entntorange focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => setDeleteModalOpen(true)}
                        >
                            Delete Selected
                        </button>
                        <button
                            type="button"
                            className="flex items-center rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-entntorange focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => setCloseModalOpen(true)}
                        >
                            Close Selected
                        </button>
                    </div>
                )}
            </div>
            <div
                className={`absolute top-10 ${isSidebarOpen ? "-left-2 shadow-md" : "-left-4 shadow-xl"} h-16 border border-gray-300 rounded-md flex items-center justify-center cursor-pointer bg-white dark:bg-darkbglight dark:border-gray-500 dark:text-gray-300`}
                onClick={handleToggle}
            >
                {isSidebarOpen ? <ChevronDoubleRightIcon width={16} /> : <ChevronDoubleLeftIcon width={16} />}
            </div>
            <ConfirmModal
                open={deleteModalOpen}
                setOpen={setDeleteModalOpen}
                onConfirm={() => {
                    onDeleteSelected();
                    setDeleteModalOpen(false);
                }}
                type="danger"
                title="Delete Issues"
                description={`Are you sure you want to delete ${selectedCount} selected issue${selectedCount > 1 ? 's' : ''}? All of the data will be permanently removed. This action cannot be undone.`}
            />
            <ConfirmModal
                open={closeModalOpen}
                setOpen={setCloseModalOpen}
                onConfirm={() => {
                    onCloseSelected();
                    setCloseModalOpen(false);
                }}
                type="danger"
                title="Close Issues"
                description={`Are you sure you want to close ${selectedCount} selected issue${selectedCount > 1 ? 's' : ''}?`}
            />
        </aside>
    );
};

export default IssueRightSideBar;
